import contractApi from "@/api/contractApi";
import { DATE_FORMAT, DATE_FORMAT_JA } from "@/common/constant";
import User, {UserDTO} from "@/model/user";
import moment from "moment";
import FileModel, { FileDTO } from "./file";
import Property from "./property";
import FloorArea from "@/model/floorArea";
import Company from "@/model/company";
import trans18next from "@/i18n";

export enum CONTRACT_HISTORY_TYPE {
  REGISTRATION = 1,
  CHANGE_DETAIL = 2,
  APPLY_MOVING_OUT = 3,
  ADD_ATTACHMENT = 4,
  REMOVE_ATTACHMENT = 5,
  CHANGE_IMAGE = 6,
  CHANGE_FILE_NAME = 7,
}

export enum CONTRACT_STATUS {
  WAIT = 0,
  CONFIRM = 1,
  CLOSE = 2,
}

export enum CONTRACT_CUSTOMER_CONFIRM {
  WAIT = 0,
  CONFIRM = 1,
}

export enum CONTRACT_TYPE {
  INDIVIDUAL = 0,
  CORPORATION = 1,
}

export enum CONTRACT_ACCEPTION {
  WAIT = 0,
  ACCEPT = 1,
  REJECT = 2,
}

export const CONTRACT_STATUS_NAME = {
  [CONTRACT_STATUS.WAIT]: 'confirm',
  [CONTRACT_STATUS.CONFIRM]: 'wait',
  [CONTRACT_STATUS.CLOSE]: 'close',
}

export enum CONTRACT_MOVING_OUT_HISTORY {
  STATUS_MOVE_OUT = 1,
  STATUS_REPAIR_REPORT = 2,
}

export enum CONTRACT_SEND_MAIL_STATUS {
  NO = 0,
  YES = 1,
}

export interface IContractor {
  id: string;
  order?: number;
  contractor_id: string;
  contractor?: User;
  type: CONTRACT_TYPE;
  no: string;
  move_in_date: string;
  status: CONTRACT_STATUS;
  contractor_name: string;
  contractor_name2: string;
  contractor_phone: string;
  resident_name: string;
  resident_name2: string;
  resident_phone: string;
  j_sys_id: string;
  j_sys?: User;
  bank_account_information: string;
  property_id: string;
  property?: Property;
  image_id: string;
  image: any;
  security_deposit: number;
  rent: number;
  common_service_fee: number;
  town_membership_fee: number;
  deposit: number;
  depreciation: number;
  files: any[];
  withdrawal_application: number;
  is_confirmed: number;
  returned_items: ReturnItem[];
  addition_items: AdditionItem[];
  is_accept: CONTRACT_ACCEPTION;
  accepted_at: string;
  room_id: string;
  count_contract_move_outs: number;
  is_send_mail: CONTRACT_SEND_MAIL_STATUS;
}

export class ReturnItem {
  id: string;
  name: string;
  number: string;
  constructor(dto = null) {
    if (dto) {
      Object.assign(this, dto);
    }
  }
}
export class AdditionItem {
  id: string;
  name: string;
  value: string;
  constructor(dto = null) {
    if (dto) {
      Object.assign(this, dto);
    }
  }
}
export class ReceiptItem {
  id: string;
  returned_item: ReturnItem;
  contract: Contract;
  created_at: string;
  constructor(dto = null) {
    if (dto) {
      Object.assign(this, dto);
    }
  }
}

export class CheckPointItem {
  id: string;
  _id: string;
  area: FloorArea;
  floor_plan_area_id: string;
  comment: string;
  images: FileModel[];
  constructor(dto = null) {
    if (dto) {
      Object.assign(this, dto);
    }
  }
}

export class ContractMovingOutHistoryItem {
  id: string;
  contract_id: string;
  status: number;
  type: number;
  target: string;
  target_destination: string;
  old_value: string;
  new_value: string;
  content: string;
  created_at: string;
  user: UserDTO;
  constructor(dto = null) {
    if (dto) {
      Object.assign(this, dto);
    }
  }

  public createdAtFormatJa() {
    if (!this.created_at) {
      return ""
    }
    return moment(this.created_at).format(DATE_FORMAT);
  }
}

export class ContractDTO implements IContractor {
  id: string;
  contractor_id: string;
  order?: number;
  contractor?: User;
  company?: Company;
  type: CONTRACT_TYPE;
  no: string;
  move_in_date: string;
  status: CONTRACT_STATUS;
  contractor_name: string;
  contractor_name2: string;
  contractor_phone: string;
  resident_name: string;
  resident_name2: string;
  resident_phone: string;
  j_sys_id: string;
  j_sys?: User;
  bank_account_information: string;
  property_id: string;
  property?: Property;
  image_id: string;
  image: any;
  security_deposit: number;
  rent: number;
  common_service_fee: number;
  town_membership_fee: number;
  deposit: number;
  depreciation: number;
  files: any[];
  withdrawal_application: number;
  is_confirmed: number;
  returned_items: ReturnItem[];
  addition_items: AdditionItem[];
  exists_account = 0;
  is_accept: CONTRACT_ACCEPTION;
  accepted_at: string;
  room_id: string;
  count_contract_move_outs: number;
  is_send_mail: CONTRACT_SEND_MAIL_STATUS;
}

export default class Contract extends ContractDTO {
  constructor(dto?: ContractDTO) {
    super();
    if (dto) {
      Object.assign(this, dto);
      if (dto.property) {
        this.property = new Property(dto.property);
      }
      this.j_sys = new User(dto.j_sys);
    } else {
      this.new();
      this.property = new Property(null);
      this.j_sys = new User();
    }

  }

  public new() {
    Object.assign(this, {
      id: null,
      company: new Company(),
      contractor_id: null,
      contractor: new User(),
      type: CONTRACT_TYPE.INDIVIDUAL,
      no: null,
      move_in_date: null,
      status: CONTRACT_STATUS.WAIT,
      contractor_name: null,
      contractor_name2: null,
      contractor_phone: null,
      resident_name: null,
      resident_name2: null,
      resident_phone: null,
      j_sys_id: null,
      bank_account_information: null,
      property_id: null,
      image_id: null,
      image: null,
      security_deposit: null,
      rent: null,
      common_service_fee: null,
      town_membership_fee: null,
      deposit: null,
      depreciation: null,
      files: [],
      withdrawal_application: null,
      is_confirmed: 0,
      returned_items: [],
      addition_items: [1, 2, 3, 4, 5].map((key) => {
        return new AdditionItem({
          id: null,
          name: null,
          value: null,
          order: key,
        });
      }),
    });
  }

  public save() {
    if (this.id) {
      return this.update();
    } else {
      return this.addNew();
    }
  }

  protected async addNew() {
    const dataTranform = Object.assign({}, this);
    if (!dataTranform.exists_account) {
      delete dataTranform.j_sys;
    }

    dataTranform.returned_items = dataTranform.returned_items.filter(item => {
      return item.name || item.number;
    });

    return await contractApi.store(dataTranform);
  }

  protected async update() {
    const dataTranform = Object.assign({}, this);
    if (!dataTranform.exists_account) {
      delete dataTranform.j_sys;
    }

    dataTranform.returned_items = dataTranform.returned_items.filter(item => {
      return item.name || item.number;
    });

    return await contractApi.update(dataTranform);
  }

  public async remove() {
    return await contractApi.remove(this.id);
  }

  get moveInDateFormat() {
    if (!this.move_in_date) {
      return ""
    }
    return moment(this.move_in_date).format(DATE_FORMAT);
  }

  get moveInDateFormatJa() {
    if (!this.move_in_date) {
      return ""
    }
    return moment(this.move_in_date).format(DATE_FORMAT_JA);
  }

  get moveOutDateFormatJa() {
    if (!this.move_in_date) {
      return ""
    }
    return moment(this.move_in_date).add(this.withdrawal_application, 'days').format(DATE_FORMAT_JA);
  }

  get statusName() {
    if (this.status === CONTRACT_STATUS.CLOSE) {
      return 'close';
    }
    if (this.is_accept == CONTRACT_ACCEPTION.ACCEPT) {
      return '';
    }
    return CONTRACT_STATUS_NAME[this.status];
  }

  public addNewReturnItem() {
    this.returned_items.push(new ReturnItem({
      id: null,
      name: null,
      number: null,
      order: moment().unix()
    }));
  }

  public removeReturnItem(index: number) {
    this.returned_items.splice(index, 1);
  }

  public addFile(result: FileDTO) {
    this.files.push(
      new FileModel({
        id: result.id,
        name: result.name,
        url: result.url,
        original_name: result.original_name,
        filename: null,
      })
    );
  }

  public removeFile(index: number) {
    this.files.splice(index, 1);
  }

  get propertyName() {
    if (!this.property) {
      return trans18next.t('data_was_transfered').toString();
    }
    return this.property.fullname;
  }
}
